import React from 'react';
import whiteBackground from '../wrapper-components/white-background';
import AttendeeSendInvitePageBody from './AttendeeSendInvitePageBody';
import { FormattedMessage } from 'react-intl';

const AttendeeSendInvitePageBooking = (props) => {
  return (
    <div className="AttendeeSendInvitePageBooking style-2 flex center">
      <div className="content-container">
        <div>
          <h2>
            <FormattedMessage id='invite.attendee_send_invite_page_booking.who_else' defaultMessage='Who else is coming?' />
          </h2>

          <h3>
            <span className="text-gray">
              <FormattedMessage id='invite.attendee_send_invite_page_booking.details' defaultMessage='Details' />
            </span>
            &nbsp;
            <i className="ico ico-sm icon-arrow-nav icon-rotate-270 arrow-title-spacing" />
            &nbsp;
            <span>
              <FormattedMessage id='invite.attendee_send_invite_page_booking.send_invite' defaultMessage='Send Invite' />
            </span>
          </h3>
        </div>

        <AttendeeSendInvitePageBody
          { ...props }
          pageType="add_invites_booking"
        />
      </div>
    </div>
  );
};

export default whiteBackground(AttendeeSendInvitePageBooking);
